import React, { FC } from 'react';
import { Loader } from '@ui-kit/components/loader';
import { SelectedAvatarIcon } from './selectedAvatarIcon';

type PropsType = {
  avatarImg: string;
  children?: never;
  isProcessing: boolean;
};

export const SelectedAvatar: FC<PropsType> = ({
  avatarImg,
  isProcessing,
}: PropsType) => {
  const iconJSX =
    isProcessing || !avatarImg ? (
      <Loader height={50} width={50} />
    ) : (
      <SelectedAvatarIcon avatarImg={avatarImg} />
    );
  return <div className="avatar-picker__select-avatar">{iconJSX}</div>;
};
